import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom'

export const OnboardingRoutes = () => {
  const User = useSelector(state => state.User)
  let isUserLoggedIn = User.user_name
  return (
    isUserLoggedIn == null ? <Outlet /> : User.user_type=="internal_user"?<Navigate to="/users"/>: <Navigate to='/dashboard' />
  )
}